<template>
  <div class="detail">
    <Header></Header>
    <div class="towns">
      <div class="name" v-for="item in towns" :key="item.id" @click="choseTown(item)" :class="{active: currentDown == item.id}">{{item.name}}</div>
    </div>
    <div class="dcontent">
      <div class="left">
        <div class="topleft cornerWraper">
          <PartHeader :title="'村庄报修统计'" />
          <DetailOrder :orderType="'修'" @typeChange="getXiuTable" :order="xiuTableData" />
        </div>
        <div class="bottomleft cornerWraper">
           <PartHeader :title="'村庄报抽统计'" />
           <DetailOrder :orderType="'抽'" @typeChange="getChouTable" :order="chouTableData" />
        </div>
      </div>      
      <div class="right">
        <div class="topright cornerWraper">
           <PartHeader :title="'实时情况'">         
            </PartHeader>
           <MapTotal :mapTotalData="mapTotalData" :totalName="totalName"/>
           <DongyingMap :left="'10%'" :mapdata="mapdata"/>
        </div>
        <div class="bottom bottomright cornerWraper">
          <PartHeader :title="'村庄报抽汇总柱状图'">
              <div class="legend">
              <!-- <div class="value value1">未抽</div> -->
                <div class="value value2">全部抽数</div>
              <!-- <div class="value value3">过期</div> -->
            </div>               
          </PartHeader>
          <Bar3 :areaBar="areaBar"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header';
import PartHeader from '../components/partHeader';
import DetailOrder from '../components/detailOrder';
import DongyingMap from '../components/map';
import MapTotal from '../components/mapTotal';
import Bar3 from '../components/bar3';
export default {
  components: {
    Header,
    PartHeader,
    DetailOrder,
    DongyingMap,
    MapTotal,
    Bar3
  },
  data() {
    return {
      currentDown: 1,
      mapTotalData: {
        order_sum: '',
        order_today: '',
        user_sum: '',
        percent: ''        
      },
      mapdata: [],   
      areaBar: [],   
      chouTableData: [],
      xiuTableData: [],
      towns: [],
      totalName: '东营区总用户量'
    }
  },
  methods: {
    choseTown(item) {
      // eslint-disable-next-line no-console
      console.log(item);
      if(item.id != this.currentDown) {
        this.currentDown = item.id;
        this.getMapDates();
        this.getTotalBar();
        this.getChouTable(3);
        this.getXiuTable(3);   
      }  
    },
    getDowns() {
      this.$fetch('/api/town/map').then(res => {
        let data = res.data.data;
        this.towns = data.areas;
        this.currentDown = this.towns[0].id;
        this.getMapDates();
      })
    },    
    getMapDates() {
      this.mapdata = [];
      this.$fetch('/api/county/map', {
        method: 'POST',
        params: {
          p_id: this.currentDown,
        }
      }).then(res => {
        let data = res.data.data;
        if(data) {      
          this.mapTotalData.order_sum = data.order_sum;
          this.mapTotalData.order_today = data.order_today;
          // 畜禽养殖区
          if(this.currentDown == '224'){
            this.mapTotalData.user_sum = data.xuqin_sum;
            this.totalName = '畜禽养殖区总用户量'
          }else {
            this.mapTotalData.user_sum = data.user_sum;
            this.totalName = '东营区总用户量'
          }       
          this.mapTotalData.percent = data.percent;
          let areas = data.areas;
          let mapdata = [];
          areas.forEach(item => {
            mapdata.push({
              name: item.name,
              value: [item.jing, item.wei, item.count ? item.count : 0],
            })
          });
          this.mapdata = mapdata;
        }
      })
    }, 
    // 村庄报抽柱状图
    getTotalBar() {
      this.areaBar = [];
      this.$fetch('/api/county/areaBar', {
        method: 'POST',
        params: {
          p_id: this.currentDown,
        }
      }).then(res => {
        if(res.data.data && res.data.data.length > 0) {
          this.areaBar = res.data.data.map(item => {
            return {
              name: item.name,
              value: Number(item.weichou) + Number(item.yichou),
              // value1: item.yichou,
              // value2: item.guoqi,
            }
          })
        }
      })      
    },  
    // 报抽表格
    getChouTable(i) {
      this.chouTableData = [];
      this.$fetch('/api/county/baochou', {
        method: 'POST',
        params: {
          p_id: this.currentDown,
          status: i,
        }
      }).then(res => {
        this.chouTableData = res.data.data;
      })        
    },
    // 报修表格
    getXiuTable(i) {
      this.xiuTableData = [];
      this.$fetch('/api/county/baoxiu', {
        method: 'POST',
        params: {
          p_id: this.currentDown,
          status: i,
        }
      }).then(res => {
        this.xiuTableData = res.data.data;
      })       
    }     
  },
  created() {
    this.getDowns();
    this.getTotalBar();
    this.getChouTable(3);
    this.getXiuTable(3);
  },
}
</script>

<style scoped>
@import './table.css';
.towns {
  margin: 20px;
  display: flex;
  justify-content: space-between;
  color: #fff;
}
.towns .name {
  line-height: 40px;
  width: 100px;
  border-radius: 4px;
  border: 1px solid #015698;
  text-align: center;
  font-size: 17px;
  cursor: pointer;
}
.towns .name.active {
  border-color:#0099FF;
}
.detail {
  height: 100%;
  overflow: hidden;
}
.dcontent {
  height: calc(100% - 190px);
  margin: 20px;
  font-size: 0;
  overflow: hidden;
}
.dcontent .left {
  display: inline-block;
  margin-right: 20px;
  width: calc(25% - 10px);
  height: 100%;
  vertical-align: top;
}
.dcontent .right {
  display: inline-block;
  width: calc(75% - 10px);
  height: 100%;
  vertical-align: top;
}
.dcontent .topright {
  margin-bottom: 20px;
  border: 1px solid #4574D6; 
  height: calc(65% - 10px);
}
.dcontent .bottomright {
  border: 1px solid #4574D6;
  height: calc(35% - 10px);
}
.dcontent .topleft {
  margin-bottom: 20px;
  border: 1px solid #4574D6;
  height: calc(50% - 10px);
}
.dcontent .bottomleft {
  border: 1px solid #4574D6;
  height: calc(50% - 10px);
}
</style>